import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaGlobe,
  FaInstagram,
  FaFacebookF,
} from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import solution from "../image/img mixfixxx.png";
import { Helmet } from "react-helmet-async";

const ContactForm = () => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const data = Object.fromEntries(new FormData(form).entries());

    try {
      const API_URL = "https://kqc4n3pmfe.execute-api.ap-south-1.amazonaws.com";
      const response = await fetch(`${API_URL}/api/contact/add`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (!response.ok) {
        toast.error(result?.message || "Something went wrong");
        return;
      }

      toast.success("Form submitted successfully");
      form.reset();
    } catch {
      toast.error("Cannot reach server. Please try again later.");
    }
  };

  return (
    <>
      {/* ================= SEO ================= */}
      <Helmet>
        <title>Contact Bait Alafnan | Property Maintenance Dubai</title>
        <meta
          name="description"
          content="Contact MA Perfect Fix for professional property maintenance services in Dubai. Electrical, plumbing, HVAC & smart home solutions."
        />
        <meta
          name="keywords"
          content="contact MA Perfect Fix, property maintenance Dubai, HVAC services Dubai"
        />

        {/* Open Graph */}
        <meta property="og:title" content="Contact MA Perfect Fix Dubai" />
        <meta
          property="og:description"
          content="Get in touch with MA Perfect Fix for trusted property maintenance services in Dubai."
        />
        <meta property="og:type" content="website" />

        {/* Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "Contact MA Perfect Fix",
            url: "https://baitalafnan.com/contact",
            mainEntity: {
              "@type": "LocalBusiness",
              name: "MA Perfect Fix",
              telephone: " +971 50 414 7991",
              email: "contact@maperfectfix.com",
              address: {
                "@type": "PostalAddress",
                addressLocality: "Dubai",
                addressCountry: "AE",
              },
            },
          })}
        </script>
      </Helmet>

      {/* ================= CONTACT SECTION ================= */}
      <section
        className="w-full bg-gradient-to-b from-[#fffdf8] via-[#fef6e4] to-[#fff3d9]
                   pt-12 sm:pt-16 md:pt-20 lg:pt-24 pb-12 text-gray-900"
        aria-label="Contact MA Perfect Fix"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">

            {/* LEFT */}
           {/* LEFT CONTENT */}
          <div className="text-center md:text-left mt-8 md:mt-6 lg:mt-4">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl 
                           font-cormorant text-[#0a1f44] mb-4 sm:mb-6 md:mb-8">
              Get in Touch
            </h2>

            <p className="text-navy-800 text-sm sm:text-base md:text-lg lg:text-xl 
                          max-w-full sm:max-w-sm md:max-w-md lg:max-w-lg 
                          mx-auto md:mx-0 leading-relaxed sm:leading-relaxed text-[#0a1f44] md:leading-loose">
              Have a question or want to work together? Fill out the form and our
              team will get back to you as soon as possible.
            </p>

            {/* CONTACT INFO */}
            <div className="mt-4 sm:mt-6 md:mt-8 space-y-2 sm:space-y-3 md:space-y-4 text-sm sm:text-base md:text-lg">
              <div className="flex items-center justify-center md:justify-start gap-2 sm:gap-3 text-[#0a1f44]">
                <FaPhoneAlt className="text-yellow-500" />
                <span> +971 50 414 7991</span>
              </div>

              <div className="flex items-center justify-center md:justify-start gap-2 sm:gap-3 text-[#0a1f44]">
                <FaEnvelope className="text-yellow-500" />
                <span>contact@baitalafnan.com</span>
              </div>

              <div className="flex items-center justify-center md:justify-start gap-2 sm:gap-3 text-[#0a1f44]">
                <FaGlobe className="text-yellow-500" />
                <span>www.baitalafnan.com</span>
              </div>
            </div>

            {/* SOCIAL */}
            <div className="mt-4 sm:mt-6 md:mt-8">
              <h3 className="font-cormorant text-[#0a1f44] text-sm sm:text-base md:text-lg lg:text-xl mb-1 sm:mb-2 md:mb-3">
                FOLLOW US
              </h3>
              <div className="flex justify-center md:justify-start gap-3 sm:gap-4 md:gap-5 
                              text-lg sm:text-xl md:text-2xl lg:text-3xl text-yellow-500">
                <FaFacebookF aria-label="Facebook" />
                <FaInstagram aria-label="Instagram" />
              </div>
            </div>
          </div>
            {/* FORM */}
            <div className="bg-white/90 backdrop-blur-md border border-yellow-300/40 shadow-lg 
                          rounded-2xl mt-8 md:mt-6 lg:mt-4 p-6 sm:p-8 md:p-10 lg:p-12">
            <form className="space-y-5 sm:space-y-6" onSubmit={handleSubmit} aria-label="Contact Form">

              {/* NAME */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <FloatingInput label="First Name *" name="firstName" required />
                <FloatingInput label="Last Name" name="lastName" />
              </div>

              {/* EMAIL & PHONE */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <FloatingInput label="Email Address *" name="email" type="email" required />
                <FloatingInput label="Phone (optional)" name="phone" />
              </div>

              {/* MESSAGE */}
              <FloatingTextarea label="Your Message *" name="message" required />

              {/* SUBMIT */}
              <div className="text-center md:text-left">
                <button
                  type="submit"
                  className="w-full sm:w-auto px-12 py-3 rounded-full text-sm sm:text-base md:text-lg 
                             font-semibold text-white bg-gradient-to-r from-yellow-400 via-yellow-500 to-yellow-600
                             shadow-md hover:scale-105 transition-transform duration-300"
                >
                  Submit
                </button>
              </div>

            </form>
          </div>

          </div>

          <div className="mt-12 flex justify-center">
            <img
              src={solution}
              alt="Property maintenance solutions in Dubai"
              className="w-full max-w-3xl"
              loading="lazy"
            />
          </div>
        </div>

        <ToastContainer position="top-right" autoClose={3000} />
      </section>
    </>
  );
};

/* INFO ROW */
// const Info = ({ icon, text }) => (
//   <div className="flex items-center justify-center md:justify-start gap-3 text-[#0a1f44]">
//     <span className="text-yellow-500">{icon}</span>
//     <span>{text}</span>
//   </div>
// );

/* FLOATING INPUT */
const FloatingInput = ({ label, name, type = "text", required }) => (
  <div className="relative">
    <input
      id={name}
      name={name}
      type={type}
      required={required}
      placeholder=" "
      className="peer w-full border border-gray-300 rounded-lg
                 px-4 py-3 focus:border-yellow-500 outline-none"
    />
    <label
      htmlFor={name}
      className="absolute left-4 -top-2.5 bg-white px-1 text-sm text-gray-600
                 peer-placeholder-shown:top-3 peer-focus:-top-2.5 transition-all"
    >
      {label}
    </label>
  </div>
);

/* FLOATING TEXTAREA */
const FloatingTextarea = ({ label, name, required }) => (
  <div className="relative">
    <textarea
      id={name}
      name={name}
      rows="5"
      required={required}
      placeholder=" "
      className="peer w-full border border-gray-300 rounded-lg
                 px-4 py-3 resize-none focus:border-yellow-500 outline-none"
    />
    <label
      htmlFor={name}
      className="absolute left-4 -top-2.5 bg-white px-1 text-sm text-gray-600
                 peer-placeholder-shown:top-3 peer-focus:-top-2.5 transition-all"
    >
      {label}
    </label>
  </div>
);

export default ContactForm;
